import axiosInstance from "../utils/axios";

const BASE_URL = "/quotes/v1";

export interface IMoneyAmount {
  currency: string;
  value: number;
}

export interface IQuoteByMoney {
  amount: IMoneyAmount;
  merchantCode: string;
  paymentProvider: string;
  basketCode?: string | null;
  programmeCode?: string | null;
}

export interface IQuoteByCo2 {
  co2Quantity: string;
  merchantCode: string;
  paymentProvider: string;
  currency: string;
  basketCode?: string | null;
  activityType: string;
  programmeCode?: string | null;
}

async function createQuoteByMoney(data: IQuoteByMoney) {
  return axiosInstance.post(`${BASE_URL}/money`, data, {})
}

async function createQuoteByCo2(data: IQuoteByCo2) {
  return axiosInstance.post(`${BASE_URL}/co2`, data, {})
}

export {
  createQuoteByMoney,
  createQuoteByCo2
}